import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {JobboardAdapter} from '../adapters/jobboard.adapter';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ISALinkResolver {
  private adapter = inject(JobboardAdapter);

  resolve(route: ActivatedRouteSnapshot): Observable<string> {
    return this.adapter.getStandaloneISAInfo(route.params['linkId']);
  }
}
